import { useMutation } from '@apollo/client'
import {
  STAFF_CHECK_DOCTOR_CSV,
  STAFF_UPLOAD_DOCTOR_CSV,
} from '@medical/constant/permissions'
import {
  checkStaffPermission,
  convertDoctorCsvRecordUpdate,
} from '@medical/libs'
import Auth from '@medical/middleware/auth'
import { useCustom } from '@medical/provider/context'
import React, { useState } from 'react'

import {
  CHECK_UPLOAD_DOCTORCSV,
  UPLOAD_DOCTOR_CSV,
} from './DoctorCsvUpdate.graphql'
import DoctorCsvUpdateScene from './DoctorCsvUpdateScene'

const DoctorCsvUpdate = () => {
  const [{ i18n, popup }] = useCustom()
  const [uploadDoctorCsv] = useMutation(UPLOAD_DOCTOR_CSV)
  const [checkUploadDoctorCsv] = useMutation(CHECK_UPLOAD_DOCTORCSV)
  const [state, setState] = useState({
    isUploaded: false,
  })
  const isUploadCheckPermitted = checkStaffPermission({
    functionName: STAFF_CHECK_DOCTOR_CSV,
  })
  const isUploadPermitted = checkStaffPermission({
    functionName: STAFF_UPLOAD_DOCTOR_CSV,
  })

  const onSubmit = async ({ data: UserCsvData }, { resetForm }) => {
    await setState({
      isUploaded: true,
    })
    try {
      if (!isUploadPermitted) {
        popup.error(i18n.t('main.noPermission'))
      } else {
        popup.info(i18n.t('staff.uploadCsv.uploading'))
        const doctorCsvRecord = convertDoctorCsvRecordUpdate(UserCsvData)
        await uploadDoctorCsv({
          variables: {
            doctorCsvRecordUpdate: doctorCsvRecord,
          },
        })
        popup.clear()
        popup.success(i18n.t('staff.uploadCsv.submissionSuccess'))
        resetForm()
      }
    } catch (error) {
      popup.clear()
      popup.error(error)
    }
    await setState({
      isUploaded: false,
    })
  }

  const checkCsvData = async ({ data: UserCsvData }, { setFieldValue }) => {
    try {
      if (!isUploadPermitted) {
        popup.error(i18n.t('main.noPermission'))
      } else {
        const doctorCsvRecord = convertDoctorCsvRecordUpdate(UserCsvData)
        const {
          data: { staffCheckUploadDoctorCsvUpdate },
        } = await checkUploadDoctorCsv({
          variables: {
            doctorCsvRecordUpdate: doctorCsvRecord,
          },
        })
        const messageAddedCsvData = UserCsvData.map((item, index) => ({
          ...item,
          errorMessage: staffCheckUploadDoctorCsvUpdate[index].errorMessage,
          checked: true,
        }))
        setFieldValue('data', messageAddedCsvData)
        popup.clear()
        popup.success(i18n.t('staff.uploadCheckCsv.submissionSuccess'))
      }
    } catch (error) {
      popup.clear()
      popup.error(error)
    }
  }

  const downloadSample = () => {
    window.location.href = `${
      process.env.REACT_APP_ENDPOINT
    }/files/医師情報_更新_サンプルcsvイメージ.csv?token=${Auth.getToken()}`
  }

  return (
    <DoctorCsvUpdateScene
      popup={popup}
      i18n={i18n}
      onSubmit={onSubmit}
      downloadSample={downloadSample}
      isUploaded={state.isUploaded}
      checkCsvData={checkCsvData}
      isUploadPermitted={isUploadPermitted}
      isUploadCheckPermitted={isUploadCheckPermitted}
    />
  )
}

export default DoctorCsvUpdate
